// @ts-nocheck
import React from 'react';
import { mdmApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  resultAsObject = false,
  hideMnemocode = false,
  ...selectProps
}) => <AutocompleteSelect style={{
  maxWidth: '100%'
}} fetch={async params => {
  return await mdmApi.fetchMdmList({
    ...filter,
    ...params
  });
}} fetchSingle={mdmApi.fetchMdmNode} notFoundText="Код не найден" placeholder="Выберите код мтр" renderOption={(mdm, Option) => <Option key={mdm.mnemocode} value={mdm.mnemocode} mdm={mdm}>
        {(hideMnemocode ? '' : `${mdm.mnemocode} - `) + mdm.name}
      </Option>} {...selectProps} />;
